import styled from 'styled-components';
import theme from '@/styles/theme';
import media from '@/styles/media';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  font-family: ${theme.fontFamily.regular};
  font-style: normal;
  height: 100%;

  ${media.lg`
    align-items: center;
    padding: 0 15px;
  `}
`;

export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 420px;
  padding-left: 120px;
  padding-right: 50px;

  min-height: calc(100% - 320px);
  justify-content: center;

  ${media.xxl`
    padding-left: 80px ;
  `}
  ${media.xl`
    padding-left: 40px ;
  `}
  ${media.lg`
    /* padding-left: 40px; */
    padding: 0;
    align-items: center;
    width: 100%;
    &.teacher-signup{
      gap: 10px;
    }
  `}
`;

export const Container = styled.div`
  display:flex;
  justify-content: space-between;
  align-items: center;
  margin: 25px 0px;
  gap: 16px;
  &.social-login {
      gap: 0px;
    }

  &.signup {
    ${media.lg`
      margin: 70px 0 0;
      width: 100%;
      gap: 16px;
    `}
  }

  ${media.md`
    gap: 14px;
  `}
  
  ${media.lg`
    &.social-login {
      /* position: fixed; */
      bottom: 4%;
      gap: 14px;
    }
  `}
`;

export const RightContainer = styled(Container)`
  margin-left: auto;
  
  ${media.lg`
    max-width: 420px;
    width: 100%;
    margin-left: 0;
    display: flex;
    justify-content: right;
    margin-bottom: 70px;
  `}
`;
